import React from "react";
import { Outlet } from "react-router-dom";
import CustomNavbar from "./CustomNavbar";

const Layout = () => {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Fixed navbar — renders itself + a 76px spacer div below it */}
      <CustomNavbar />

      {/* Page content — sits below the spacer, never hidden behind nav */}
      <main style={{ flex: 1 }}>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;